// Function to show error message

// Since the functions return the promise, you can also use .then()

async function updateQuantityInput(inputEl, alertWhenOutOfStock = false) {
	const parent = $(inputEl).closest(".hulk_line_item");
	const variantId = parent.find("[name^=variant]").val();
	const input = $(inputEl);
	const id = input.attr("id");
	const counter = B2BUtils.getNumberFromString(id);
	let maxQuantity = parseInt(document.getElementById('stock_' + counter).value);
	let quantity = parseInt(input.val()) || 0;
	const bunk = await B2BUtils.getProductBunk(variantId);
	parent.addClass("updating-quantity");
	maxQuantity = maxQuantity - (maxQuantity % bunk);

	if(maxQuantity < bunk && alertWhenOutOfStock ){
		alert("Product is already sold out");
	}
	
	if(maxQuantity <= 0 && alertWhenOutOfStock) {
		alert("Product is already sold out");
	}

	if(quantity > maxQuantity){
		quantity = maxQuantity;
	}

	const adjustedQuantity = getQuantity(quantity, bunk);
	input.val(adjustedQuantity);
	input.prop("step", bunk);

	Pricerow(adjustedQuantity, counter);

	parent.removeClass("updating-quantity");
}

function getQuantity(number = 0, bunk = 1) {
	if (number % bunk !== 0) {
		return Math.ceil(number / bunk) * bunk;
	}

	return number;
}

function quantityfunctionBtn(data, counter) {
	const input = document.getElementById("quantity_" + counter);
	let value = parseInt(input.value);
	const step = input.step ? parseInt(input.step) : 1;
	if (data == "plus") {
		value += step;
		value = getQuantity(value, step);
		document.getElementById("quantity_" + counter).innerHTML = value;
	} else {
		if (value >= 1) {
			value -= step;
			value = getQuantity(value, step);
			if (value > 1) {
				document.getElementById("quantity_" + counter).innerHTML =
					value;
			}
		}
	}
	document.getElementById("quantity_" + counter).value = value;
	if (value <= 0) {
		document.getElementById("error_quantity_" + counter).innerHTML =
			popup_translation && popup_translation.minimum_qty
				? popup_translation.minimum_qty
				: "Minimum quantity is " + step;
		buttondisable(true);
		// document.getElementById('reorder_button').disabled = true;
	} else {
		document.getElementById("error_quantity_" + counter).innerHTML = "";
		// document.getElementById('reorder_button').disabled = false;
		buttondisable(false);
		Pricerow(value, counter);
		return true;
	}
}

function checkItemsInOrder() {
	const quantityInputs = $(
		"#hulkapp_reorder_master input.hulk_qty_input[type='number']",
	);

	jQuery.each(quantityInputs, async function () {
		await updateQuantityInput(this);
	});
}

// check XMLHttpRequest complete
// Track progress
request.onreadystatechange = function () {
	const url = request._url;
	const isGetOrder = url.includes("api/get-order");

	if (
		isGetOrder &&
		request.readyState === XMLHttpRequest.DONE &&
		request.status === 200
	) {
		setTimeout(() => {
			checkItemsInOrder();
		}, 0);
	}
};

jQuery(document).on('change', '.hulk_qty_input', function(){
	setTimeout(() => {
		updateQuantityInput(this, true);
	})
});
